import { create } from 'zustand';

interface GlobalStore {
    loading: boolean;
    setLoading: (obj: boolean) => void;

    errMsg: string;
    setErrMsg: (obj: string) => void;

    showErrMsg: boolean;
    setShowErrMsg: (obj: boolean) => void;

    showTokenExpired: boolean;
    setShowTokenExpired: (obj: boolean) => void;
}

const useGlobalStore = create<GlobalStore>((set) => ({
    loading: false,
    setLoading: (obj) => set({ loading: obj }),

    errMsg: '',
    setErrMsg: (obj) => set({ errMsg: obj }),

    showErrMsg: false,
    setShowErrMsg: (obj) => set({ showErrMsg: obj }),

    showTokenExpired: false,
    setShowTokenExpired: (obj) => set({ showTokenExpired: obj }),
}));

export default useGlobalStore;
